module.exports = __webpack_public_path__ + "img/emoji-neutral-face.e1e93c85.svg";